import "./ModeSelect.css";

/*
  ModeSelect.jsx — Mode selection screen

  Shown before any upload. User picks their workflow:

  Free tier (2 modes):
  - "vessel"  — I know my vessel (safe for any file size)
  - "explore" — I just have a file (small files only, warns user)

  Pro tier (3 modes):
  - "vessel"  — I know my vessel
  - "explore" — I just have a file
  - "multi"   — Multi-file consolidation (requires vessel target)
*/

export default function ModeSelect({ onSelect, unlocked }) {
  return (
    <div className="mode-select">
      <p className="mode-select-title">How would you like to start?</p>
      <p className="mode-select-hint">Choose a workflow — you can change it any time.</p>

      <div className="mode-cards">

        {/* Mode 1 — I know my vessel */}
        <button className="mode-card" onClick={() => onSelect("vessel")}>
          <span className="mode-card-icon">🔍</span>
          <span className="mode-card-title">I know my vessel</span>
          <span className="mode-card-desc">
            Enter an MMSI or vessel name first. The parser will search only for
            your vessel — works safely with any file size including large NOAA files.
          </span>
        </button>

        {/* Mode 2 — I just have a file */}
        <button className="mode-card" onClick={() => onSelect("explore")}>
          <span className="mode-card-icon">📂</span>
          <span className="mode-card-title">I just have a file</span>
          <span className="mode-card-desc">
            Drop in a file and see all vessels in it. Best for small files.
          </span>
          <span className="mode-card-warning">
            ⚠ Large files may be slow or unresponsive
          </span>
        </button>

        {/* Mode 3 — Multi-file consolidation (Pro only) */}
        {unlocked && (
          <button className="mode-card mode-card--pro" onClick={() => onSelect("multi")}>
            <span className="mode-card-icon">📁</span>
            <span className="mode-card-title">Multi-file consolidation</span>
            <span className="mode-card-desc">
              Upload files from multiple days and stitch them into one unified
              track. Requires a vessel target.
            </span>
            <span className="mode-card-pro-badge">Pro</span>
          </button>
        )}

      </div>
    </div>
  );
}
